/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo } from 'react'
import {
  Panel,
  Title,
} from '@ui5/webcomponents-react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import Slide from '@mui/material/Slide';
import Container from '@mui/material/Container';
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from "axios"
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import ScoreCardPopup from '../components/ScoreCardPopup'
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { useTableStyles } from '../utils/tableStyles'
import { useTheme } from '../utils/ThemeContext'
import '../styles/MaterialTableStyles.css';

const MEMBERSTATS_PAGE_SIZE_KEY = 'memberstats_pageSize';

const MemberStats = () => {
  const { theme } = useTheme();
  const { panelBackgroundColor, muiTableBodyCellSx, muiTableHeadCellSx, muiPaginationSx, muiTablePaperSx, muiTopToolbarSx, muiBottomToolbarSx } = useTableStyles();
  //retrieve any search Params
  const location  = useLocation();
  const id = new URLSearchParams(location.search).get('id')
  const year = new URLSearchParams(location.search).get('year')
  const navigate = useNavigate()

  //results from backend.  useState in order to share the data across functions/components
  const [currentMemberName, setCurrentMemberName] = useState("")
  const [currentMemberHcp, setCurrentMemberHcp] = useState("")
  const [currentEagles, setCurrentEagles] = useState("")
  const [currentBirdies, setCurrentBirdies] = useState("")
  const [currentPars, setCurrentPars] = useState("")
  const [currentBogeys, setCurrentBogeys] = useState("")
  const [currentDoubles, setCurrentDoubles] = useState("")
  const [currentOther, setCurrentOther] = useState("")
  const [loadingStats, setLoadingStats] = useState(true)
  const [roundsData, setRoundsData] = useState([])
  const [currentYear, setCurrentYear] = useState(year)
  const [hideResultsTable, setHideResultsTable] = useState("flex")
  const [selectedRow, setSelectedRow] = useState(null)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: parseInt(sessionStorage.getItem(MEMBERSTATS_PAGE_SIZE_KEY) || '10', 10),
  })

  //get the needed data for the standings and stats
  useEffect(() => {
    setLoadingStats(true)
    getData(id, currentYear)
  }, [id, currentYear])
  
  async function getData(id, year) {
    axios.all([
        axios.get("api/players/read_one.php?playerID=" + id + "&year=" + year),
        axios.get("api/scores/readByPlayerID.php?playerID=" + id + "&year=" + year)
    ])
    .then(axios.spread((obj1, obj2) => {
        setCurrentMemberName(obj1.data.firstName + " " + obj1.data.lastName)
        setCurrentMemberHcp(obj1.data.handicap)
        setCurrentEagles(obj1.data.eagles)
        setCurrentBirdies(obj1.data.birdies)
        setCurrentPars(obj1.data.pars)
        setCurrentBogeys(obj1.data.bogeys)
        setCurrentDoubles(obj1.data.doubles)
        setCurrentOther(obj1.data.otherScores)
        if(obj2.data.records == null){
          setHideResultsTable("none")
        }
        else{
          setRoundsData(obj2.data.records)
          setHideResultsTable("flex")
        }
    })).catch((error) =>{
      console.error("Error fetching data: ", error)
    }).finally(() => {
      setLoadingStats(false)
    })
  }

  const handleYearChange = (event) => {
    setCurrentYear(event.target.value)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(
    () => [
              {
                header: 'Date',
                accessorKey: 'datePlayed',
                size: 60,
                Cell: ({renderedCellValue, row}) => {
                  const data = row.original;
                  return(
                    <div onClick={(e) => e.stopPropagation()}>
                    <ScoreCardPopup 
                        datePlayed = {data.datePlayed}
                        scoreID = {data.scoreID}
                        courseName = {data.courseName}
                        courseID = {data.course}
                  />
                  </div>
                  );
                }
              },
              {
                header: 'Course',
                accessorKey: 'courseName',
                size: 80
              },
              {
                header: 'Gross',
                accessorKey: 'grossTotal',
                size: 60
              },
              {
                header: 'Net',
                accessorKey: 'netTotal',
                size: 40
              },
              {
                header: 'Pts',
                accessorKey: 'points',
                size: 40
              }
            ]
    );

 
    const table = useMaterialReactTable({
    columns,
    data: roundsData,
    enableColumnPinning: true,
    enableStickyHeader: true,
    enableTopToolbar: false,
    enableColumnActions: false,
    initialState: { density: 'compact' },
    layoutMode: 'grid',
    state: { isLoading: loadingStats, pagination },
    onPaginationChange: (updater) => {
      setPagination((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        sessionStorage.setItem(MEMBERSTATS_PAGE_SIZE_KEY, String(next.pageSize));
        return next;
      });
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => setSelectedRow(row.original),
      sx: { cursor: 'pointer' },
    }),
    muiTableBodyCellProps: {
      sx: muiTableBodyCellSx,
    },
    muiTableHeadCellProps: {
      sx: muiTableHeadCellSx,
    },
    muiTablePaperProps: { sx: muiTablePaperSx },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    muiPaginationProps: {
      showFirstButton: false,
      showLastButton: false,
      rowsPerPageOptions: [10, 25],
      sx: muiPaginationSx,
    },
  });


 return(
  <Stack>
  <Slide id="memberDetailsSlide" direction="up" in={true} timeout={{ enter: 1000, exit: 0, }} mountOnEnter unmountOnExit>
    <Panel fixed stickyHeader style={{backgroundColor: panelBackgroundColor}} 
        header={<><ArrowBackIcon onClick={() => navigate(-1)} style={{ verticalAlign: 'middle', color: theme.primary, cursor: 'pointer' }} />
                  <span style={{paddingLeft: "10px"}}>{currentMemberName} ({currentMemberHcp})</span></>}
    >
    <Box display="flex" alignItems="center" justifyContent="center" pt={1} pb={1} gap={2}>
      <span style={{ fontSize: '1rem', fontWeight: 'bold', color: theme.primary }}>Stats for</span>
      <FormControl size="small">
        <InputLabel id="year-select-label">Year</InputLabel>
        <Select
          labelId="year-select-label"
          value={currentYear}
          onChange={handleYearChange}
          label="Year"
          sx={{ minWidth: 90, color: theme.primary, '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.primary }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.primaryHover } }}
        >
          <MenuItem value="2026">2026</MenuItem>
          <MenuItem value="2025">2025</MenuItem>
          <MenuItem value="2024">2024</MenuItem>
          <MenuItem value="2023">2023</MenuItem>
          <MenuItem value="2022">2022</MenuItem>
          <MenuItem value="2021">2021</MenuItem>
        </Select>
      </FormControl>
    </Box>
      <table style={{paddingTop: "12px", fontSize: "13px"}} align="center">
        <thead>
          <tr>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Eagles</th>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Birdies</th>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Pars</th>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Bogeys</th>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Doubles</th>
          <th align="center" style={{paddingLeft: "4px", paddingRight: "4px"}}>Other</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          <td align="center">{currentEagles}</td>
          <td align="center">{currentBirdies}</td>
          <td align="center">{currentPars}</td>
          <td align="center">{currentBogeys}</td>
          <td align="center">{currentDoubles}</td>
          <td align="center">{currentOther}</td>
          </tr>
        </tbody>
      </table>
      <Box pt={3} pb={3}>
        <Title level="H3" align="center">Rounds</Title>
      </Box>
      <Box id="box-for-table" sx={{textAlign: "center"}} display={hideResultsTable}>
        <Container>
        <MaterialReactTable 
          table={table} />
        </Container>
      </Box>
      {selectedRow && (
        <ScoreCardPopup
          open={true}
          onClose={() => setSelectedRow(null)}
          datePlayed={selectedRow.datePlayed}
          scoreID={selectedRow.scoreID}
          courseName={selectedRow.courseName}
          courseID={selectedRow.course}
        />
      )}
    </Panel>  
  </Slide>
</Stack>
    )
  }
  
  export default MemberStats; 